import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SvgIconComponent } from './shared/svg-icon/svg-icon.component';
import { SvgComponent } from './shared/svg/svg.component';


import { FooterComponent } from './footer/footer.component';
import { GooglemapsWrapperModule } from './googlemaps-wrapper/googlemaps-wrapper.module';
import { ButtonComponent } from './shared/button/button.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BeachWatchMapModule } from './beach-watch-map/beach-watch-map.module';
import { ModelModule } from './models/model.module';
import { HomeModule } from './home/home.module';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientXsrfModule } from '@angular/common/http';
import { HttpClientJsonpModule } from '@angular/common/http';

import { RequestCache, RequestCacheWithMap } from './services/common/request-cache.service';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AuthService } from './services/common/auth.service';
import { HttpErrorHandler } from './services/common/http-error-handler.service';
import { MessageService } from './services/common/message.service';
import { httpInterceptorProviders } from './http-interceptors';
import { SiteDetailsModule } from './site-details/site-details.module';


import { ZoomToSearchResultService } from './beach-watch-map/ZoomToSearchResultService';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FavouritesModule } from './your-favourites/favourites.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BeachwatchPartnersModule } from './beachwatch-partners/beachwatch-partners.module';
import { WaterMonitoringModule } from './water-monitoring/water-monitoring.module';
import { SubscriptionsModule } from './user-subscriptions/subscriptions.module';
import { WhatIsBeachwatchModule } from './what-is-beachwatch/what-is-beachwatch.module';
import { ContactUsModule } from './contact-us/contact-us.module';
import { ReportPollutionComponent } from './report-pollution/report-pollution.component';
import { HeaderModule } from './header/header.module';
import { NavigationMenuModule } from './navigation-menu/navigation-menu.module';
import { SharedCompsModule } from './shared/shared-comps.module';
import { AppMonitoringService } from './services/logging.service';


@NgModule({
	declarations: [
		AppComponent,
		SvgIconComponent,
		SvgComponent,		
		FooterComponent,			
		ButtonComponent, 
		ReportPollutionComponent
	],
	imports: [
		BrowserModule, 
		AppRoutingModule, 
		FormsModule,
		HttpClientModule, // import Http modules after the BrowserModule
		HttpClientJsonpModule,
		HttpClientXsrfModule,
		HttpClientInMemoryWebApiModule,
		GooglemapsWrapperModule, 
		BrowserAnimationsModule, 
		BeachWatchMapModule, 
		ModelModule, 
		HomeModule,
		SiteDetailsModule,
		WaterMonitoringModule,
		FavouritesModule,			
		ReactiveFormsModule,
		BeachwatchPartnersModule,
		WhatIsBeachwatchModule,
		ContactUsModule,
		SubscriptionsModule, 
		HeaderModule,
		NavigationMenuModule,
		SharedCompsModule
	],
	providers: [
		AuthService,
		AppMonitoringService,
		HttpErrorHandler,
		MessageService,		
		{ provide : RequestCache, useClass: RequestCacheWithMap },		
		ZoomToSearchResultService,
		httpInterceptorProviders
	],		
	bootstrap: [AppComponent]
})
export class AppModule {}
